import type { FC } from "react";
import React, { useCallback } from "react";
import { Button } from "@material-ui/core";
import contractOfOfferDoc from "../../../documents/contract_of_offer.pdf";
import privacyPolicyDoc from "../../../documents/privacy_policy.pdf";
import { useLocalStorage } from "../../../hooks/local_storage";

import "./styles.scss";

export const Agreement: FC = () => {
    const [personalDataAgree, setPersonalDataAgree] = useLocalStorage("personalDataAgree", "");
    const handleClick = useCallback(() => setPersonalDataAgree("true"), []);

    if (personalDataAgree === "true") {
        return null;
    }

    return (
        <div className="agreement-container">
            <div className="agreement-content">
                <div>
                    Продолжая использовать сайт, вы&nbsp;принимаете условия{" "}
                    <a href={contractOfOfferDoc} rel="noreferrer" target="_blank" download="Договор оферты.pdf">
                        соглашения
                    </a>{" "}
                    и даю своё согласие на&nbsp;
                    <a
                        href={privacyPolicyDoc}
                        rel="noreferrer"
                        target="_blank"
                        download="Политика конфиденциальности.pdf"
                    >
                        передачу и&nbsp;обработку персональных данных и&nbsp;cookies
                    </a>
                    .
                </div>
                <Button color="primary" onClick={handleClick} size="medium" variant="contained">
                    Хорошо
                </Button>
            </div>
        </div>
    );
};
